import { render } from "./AccX.vue?vue&type=template&id=ebb1d98e"
import script from "./AccX.vue?vue&type=script&lang=js"
export * from "./AccX.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__